export const OtherToolsData = [
    {
        title: 'Beratungsangebote',
        href: 'Linksammlung zu Beratung',
    },
    {
        title: 'Fachschaft Medizin',
        href: 'http://fsi-charite.de/'},
    {
        title: 'Progress Test Medizin (PTM)',
        href: 'https://progress-test-medizin.charite.de/'},
    {
        title: 'Webseite Charité Lehre',
        href: 'https://www.charite.de/studium_lehre/struktur_einrichtungen/'},
    {
        title: 'Evaluation',
        href: 'https://intranet.charite.de/evaluation/evaluationsergebnisse/',
    },
    {
        title: 'Ordnungen',
        href: 'https://www.charite.de/studium_lehre/studiengaenge/modellstudiengang_humanmedizin/'},

     {
        title: 'Medizinische Bibliothek',
        href: 'https://bibliothek.charite.de/'
    },
    {
        title: 'CIPOM',
        href: 'https://cipom.charite.de/'
    },
    {
        title: 'Lernzentrum',
        href: 'https://lernzentrum.charite.de/'
    }
];

export const StudyToolsData = [
    {
        title: 'LLP',
        href: 'https://lernziele.charite.de'
    },
    {
        title: 'HIS',
        href: 'https://his.charite.de'
    },
    {
        title: 'Campusnet',
        href: 'https://campusnet.charite.de'
    },
    {
        title: 'Blackboard',
        href: 'https://lms.charite.de'},
    {
        title: 'TellMe',
        href: 'https://dsfz-online.charite.de/'
    },
    {
        title: 'Minerva (Hausarbeit M23)',
        href: 'https://minerva.charite.de/'
    },
    {
        title: 'Lernzentrum (Raumbuchung)',
        href: 'https://lernzentrum.charite.de/leistungen/raumbuchung/'
    },
    {
        title: 'Moses',
        href: 'https://moses.charite.de'
    },
    {
        title: 'Wikiblog',
        href: 'https://wikiblog.charite.de'}

];
